import { axios } from '@ben/api/axios';
import { captureError } from '@ben/api/capture-error';
import { optionalString } from '@ben/shared/utils/zod';
import { z } from 'zod';
import { employerConfigurationValuesSchema } from '../schema/employer-configuration-values';

export const uiConfigSchema = z.object({
  leftNav: z.object({
    hasBenefits: z.boolean(),
    hasRewards: z.boolean(),
    hasWallet: z.boolean(),
    hasUnseenRewards: z.boolean(),
    hasEquityModeler: z.boolean().optional(),
    hasResources: z.boolean(),
    hasTotalRewards: z.boolean().optional(),
  }),
  headerMenu: z.object({
    isManager: z.boolean(),
    isAdmin: z.boolean(),
  }),
  employerConfiguration: z
    .object({
      adminHelpDeskUrl: z.string(),
      canCreateBenefit: z.boolean(),
      canViewCompanyWallet: z.boolean(),
      canViewCompensationCard: z.boolean(),
      canViewContributionCard: z.boolean(),
      canViewSearch: z.boolean().optional(),
      canViewRemoteActivities: z.boolean().optional(),
      canEmployeeViewIntercomMessenger: z.boolean(),
      canEmployeeViewIntercomSurveys: z.boolean(),
      canAdminViewIntercom: z.boolean(),
      canViewInvoices: z.boolean(),
      canViewMoneyManagement: z.boolean(),
      canViewEquityModeler: z.boolean().optional(),

      canViewResourcesHub: z.boolean().optional(),
      resourcesHubName: z.string().nullable().optional(),
      enableHrisIntegrationConfig: z.boolean(),
      helpDeskUrl: z.string(),
      values: employerConfigurationValuesSchema,
      isWhitelabel: z.boolean(),
      mobileAppUrl: optionalString,
      allowContactEmailUsage: z.boolean(),
      hasRewardsAndRecognition: z.boolean(),
    })
    .nullable(),
  employeeConfiguration: z
    .object({
      hasLoggedIntoMobileApp: z.boolean(),
      hasSeenMobileAppDiscoverabilityBanner: z.boolean(),
      hasSeenOnboardingChecklistModal: z.boolean(),
    })
    .nullable(),
});

export type UiConfig = z.infer<typeof uiConfigSchema>;

export const getUiConfig = async (): Promise<UiConfig> => {
  const response = await axios.get('ui-config/');

  try {
    return uiConfigSchema.parse(response?.data);
  } catch (error) {
    captureError(error);
  }
  return response?.data as UiConfig;
};

export default getUiConfig;
